export const USER_STATUS_SUPER = "SUPER";

export const TIP_CHARGE = "restaurantTippingCharges";

export const BILL_ELEMENT_ENTRIES = {
    GST: "GST",
    TO_PAY: "To Pay",
    TOTAL_BILL_AMOUNT: "Total bill amount",
    ADVANCE_AMOUNT: "Cover charge redeemed",
    DISCOUNT_TYPE_FLAT: "FLAT",
    INR_CURRENCY_SYMBOL: "₹",
    MINUS_SYMBOL: "-",
    CONVENIENCE_FEE_TYPE: "convenienceFee",
    TOTAL_BILL_AMOUNT_ID: "billAmount",
    PLAN_AMOUNT_ID: "planAmount",
    BILL_TO_PAY_ID: "billToPay",
    ADD_TIP_ID: "addTip",
    DISCOUNT_ID: "discount_",
    AMOUNT_PAID: "Amount Paid",
    ADVANCE_AMOUNT_ID: "advance_",
};

export enum DealCategory {
    BAU = "Pre-Book",
    GIRF = "GIRF",
}

export const AMOUNT_FORMAT = `₹{0}`;

export const INR_CURRENCY_SYMBOL_TEXT = "\u20B9{0}";

export const DO_HELP_WEBVIEW_DEFAULT_URL = "https://www.swiggy.com/support/dineout-issues";

export enum COUPON_TYPE {
    FLAT = "FLAT",
    PERCENT = "PERCENT",
    STORE_DISCOUNT = "StoreDiscount",
}

export const Remove = "Remove";
export const OFFER_HEADER = "Additional Offers";
export const APPLY_COUPON_TEXT = "Apply coupon & Bank Offers";
export const CouponSubtitleDimension = "20";

export const AnimationConfig = (isCongratsAnim: boolean) => {
    return {
        loop: isCongratsAnim,
        autoplay: true,
        backwardSpeed: 1,
        forwardSpeed: 1,
        playIfVisible: true,
    };
};

export const LOTTIE_ANIMATIONS = {
    CONGRATS_LOTTIE: "portal/m/dineout/dineout_congrats.json",
    SMILEY_LOTTIE: "portal/m/dineout/emoji-glass.json",
    MONEY_LOTTIE: "portal/static-assets/lotties/dineout/loyalty/PS-LottieDC1.json",
};

export const ONE_WHITE_CLOUDINARY_URL = "portal/m/dineout/one_white.webp";

export const LOTTIE_ANIMATIONS_CONGRATS_PROPS = AnimationConfig(false);

export const LOTTIE_ANIMATIONS_SMILEY_PROPS = AnimationConfig(true);

export const LOTTIE_ANIMATIONS_MONEY_PROPS = AnimationConfig(false);

export const LOTTIE_ANIMATIONS_BOOSTER_PROPS = AnimationConfig(false);

export const ANIMATION_DEFAULT_TIMEOUT = 2000;
export const ANIMATION_TIMEOUT = 1000;
export const ANIMATION_TIMEOUT_MONEY = 750;

export const YOU_PAY = "Your bill";

export const SAVING_IMAGE_DIMENSTION = {
    height: "40px",
    width: "60px",
};

export const PROCEED_TOPAY_TEXT = "Proceed to Pay";
export const PAYING = "Paying: {0}";

export const GO_AHEAD = "Yes, go ahead";
export const GO_BACK = "No, go back";
export const CONFIRM_SETTLE_BILL = "Are you sure you want to settle the bill?";

export const COUPON_HEADER = "DISCOUNT_CARD_HEADER";
export const REDEEMABLE_TEXT_GAP = 10;
export const GO_BACK_KEY = "go-back";
export const SETTLE_KEY = "settle";

export const DINEOUT_SHOW_COUPON_SECTION_ANIMATION_STORAGE_KEY = "dineout_show_coupon_section_animation";
export const COUPON_SECTION_SHAKE_ANIMATION_TIMEOUT = 3200; // 1.2s animation duration + 2s delay

export const REWARD_LOGO_HEIGHT_WIDTH = "26px";
export const BOOSTER_LOGO_HEIGHT_WIDTH = 28;
export const CALLOUT_ICON_HEIGHT_WIDTH = "71px";

export const LOTTIE_CONTAINER = {
    TOP_POSITION: "50px",
    WIDTH_WITH_TITLE: "114px",
    WIDTH_WITHOUT_TITLE: "50px",
    HEIGHT_WITH_TITLE: "104px",
    HEIGHT_WITHOUT_TITLE: "42px",
} as const;

export const BOOSTER_ANIMATION_START_DELAY = 1400;
export const BOOSTER_ANIMATION_TIMEOUT = 3000; //  1.6s animation duration + 1.4s delay
export const DINEOUT_SHOW_BOOSTER_ANIMATION_STORAGE_KEY = "dineout_show_booster_animation";
